angular.module('SpidApp')

.factory('StockManagerUtils', 
		['STOCKFLOW_CONFIG', 
function (STOCKFLOW_CONFIG) {
	var StockManagerUtils = {
			
		agregateProductAndStock: function(productArray, stockArray, type) {
			var result = _.map(productArray, function(product) {
	    	    var entry = _.find(stockArray, function(stock) {
	    	    	return product.id === stock.orderable_id;
    	    	});
	    	    
	    	    var data = { product : product, quantity : 0, qtyOrigine : 0 }
	    	    if (type && type === STOCKFLOW_CONFIG.type.output) {
	    	    	data.quantity = -product.quantity
	    	    	data.diff     = -product.quantity
	    	    }
	    	    else if (type && type === STOCKFLOW_CONFIG.type.input) {
	    	    	data.quantity = +product.quantity_get || 0
	    	    	data.diff     = +product.quantity_get || 0
	    	    }
	    	    
	    	    if (entry) {
	    	    	data.quantity   = entry.quantity;
	    	    	data.qtyOrigine = entry.quantity;
	    	    	
	    	    	if (type && type === STOCKFLOW_CONFIG.type.output) {
	    	    		data.quantity = entry.quantity - +product.quantity;
	 	    	    }
	    	    	else if (type && type === STOCKFLOW_CONFIG.type.input) {
	    	    		data.quantity = entry.quantity + (+product.quantity_get);
	 	    	    }
	    	    }
	    	    return data;
	    	});
			return result;
		}
	}

	return StockManagerUtils
}])

.factory('StockManager',
		['Stock', 'StockService', 'StockFlow', 'StockFlowService', 'StockManagerUtils', 'STOCKFLOW_CONFIG', 
function (Stock,   StockService,   StockFlow,   StockFlowService,   StockManagerUtils,   STOCKFLOW_CONFIG) {
	var StockManager = {
			
		agregateProductAndStock: function(productArray, stockArray) {
			return StockManagerUtils.agregateProductAndStock(productArray, stockArray);
		},
		
		outOfStockProduct: function(productArray, stockArray) {
			return StockManagerUtils.agregateProductAndStock(productArray, stockArray, STOCKFLOW_CONFIG.type.output);
		},
		
		manageOutOfStock: function(saleProducts, agencyId) {
			return StockService.findByAgencyId(agencyId).then(function (stocks) {
				var stockProducts = StockManagerUtils.agregateProductAndStock(saleProducts, stocks, STOCKFLOW_CONFIG.type.output);
				
				stocks = _(stockProducts).map(function(stockProduct) {
	    			var stock = new Stock();
	        		stock.initFromStockProduct(stockProduct, agencyId);
	        		return stock;
	    		}) 
	    		
	    		return StockService.bulkSave(stocks, agencyId).then(function () {
	    			var stockFlows = _.chain(stockProducts).map(function(stockProduct) {
	    				var stockFlow = new StockFlow({
	    					orderable_id	: stockProduct.product.id
	    					, agency_id		: agencyId
	    					, diff			: stockProduct.diff
	    					, current		: stockProduct.quantity
	    				});
	        			stockFlow.setTypeOutput();
	        			return stockFlow
	        		}).value();
	    			return StockFlowService.bulkSave(stockFlows, agencyId);
	    		})
			}).catch(function (error) {
				console.error('StockService::save() - ', error)
			});
		},
		
		manageInOfStock: function(orderProducts, agencyId) {
			return StockService.findByAgencyId(agencyId).then(function (stocks) {
				var stockProducts = StockManagerUtils.agregateProductAndStock(orderProducts, stocks, STOCKFLOW_CONFIG.type.input);
				
				stocks = _(stockProducts).map(function(stockProduct) {
	    			var stock = new Stock();
	        		stock.initFromStockProduct(stockProduct, agencyId);
	        		return stock;
	    		}) 
	    		
	    		return StockService.bulkSave(stocks, agencyId).then(function () {
	    			var stockFlows = _.chain(stockProducts).map(function(stockProduct) {
	    				var stockFlow = new StockFlow({
	    					orderable_id	: stockProduct.product.id
	    					, agency_id		: agencyId
	    					, diff			: stockProduct.diff
	    					, current		: stockProduct.quantity
	    				});
	        			stockFlow.setTypeInput();
	        			return stockFlow
	        		}).value();
	    			return StockFlowService.bulkSave(stockFlows, agencyId);
	    		})
			}).catch(function (error) {
				console.error('StockService::save() - ', error)
			});
		},
		
		saveStockProduct: function(stockProduct, agencyId) {
	    	var stock = new Stock();
			stock.initFromStockProduct(stockProduct, agencyId);
			
			return StockService.save(stock, agencyId).then(function(){
				stockProduct.quantity = stockProduct.quantity || 0;
				if (stockProduct.quantity === stockProduct.qtyOrigine) {
					return;
				}
				var stockFlow = new StockFlow();
				stockFlow.initFromStockProduct(stockProduct, agencyId);
				stockFlow.setTypeRec();
				return StockFlowService.save(stockFlow, agencyId, stock.orderable_id);
				
			}).then(function() {
				stockProduct.qtyOrigine = stockProduct.quantity;
			}).catch(function (error) {
				console.error('StockService::save() - ', error)
			});
	    },
	    
	    saveStockProducts: function(stockProducts, agencyId) {
	    	var stocks = _(stockProducts).map(function(stockProduct) {
				var stock = new Stock();
	    		stock.initFromStockProduct(stockProduct, agencyId);
	    		return stock;
			})
			
			return StockService.bulkSave(stocks, agencyId).then(function () {
				var stockFlows = _.chain(stockProducts).filter(function(stockProduct) {
					stockProduct.quantity = stockProduct.quantity || 0;
					return stockProduct.quantity !== stockProduct.qtyOrigine;
					
				}).map(function(stockProduct) {
					var stockFlow = new StockFlow();
	    			stockFlow.initFromStockProduct(stockProduct, agencyId);
	    			stockFlow.setTypeRec();
	    			return stockFlow
	    		}).value();
				
				return StockFlowService.bulkSave(stockFlows, agencyId);

			}).catch(function (error) {
				console.error('StockService::save() - ', error)
			})
	    }
		
		
	}

	return StockManager
}])